import { createRouter, createWebHistory } from '@ionic/vue-router';
import Home from '@/views/Home.vue';

export default createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        {
            path: '/item/:key',
            name: 'Item',
            component: () => import('@/views/Item.vue'),
        },
        {
            path: '/item/:key/:ymd',
            name: 'CheckIn',
            component: () => import('@/views/CheckIn.vue'),
        },
        {
            path: '/item/:key/chart',
            name: 'ChartDetail',
            component: () => import('@/views/GoalChartDetail.vue'),
        },
        {
            path: '/edit/:key?',
            name: 'EditItem',
            component: () => import('@/views/EditItem.vue'),
        },
        {
            path: '/settings',
            name: 'Settings',
            component: () => import('@/views/Settings.vue'),
        },
        {
            path: '/about',
            name: 'About',
            component: () => import('@/views/AboutApp.vue'),
        },
        {
            path: '/storage',
            name: 'Storage',
            component: () => import('@/views/Storage.vue'),
        },
    ],
});